import {
  Directive,
  ElementRef,
  Renderer2,
  AfterViewInit,
  OnDestroy,
} from "@angular/core";

@Directive({
  selector: "[appDelayStopAnimation]",
})
export class DelayStopAnimationDirective implements AfterViewInit, OnDestroy {
  private observer: IntersectionObserver;
  private timeoutId: any;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Delay removing the animation class
          this.timeoutId = setTimeout(() => {
            this.renderer.removeClass(this.el.nativeElement, "animate");
          }, 4000); // 4s delay
        } else {
          // Instantly add the animation class back
          clearTimeout(this.timeoutId);
          this.renderer.addClass(this.el.nativeElement, "animated");
        }
      });
    });

    // Defer observing until element is rendered
    setTimeout(() => {
      this.observer.observe(this.el.nativeElement);
    }, 0);
  }

  ngOnDestroy() {
    if (this.observer) this.observer.disconnect();
    if (this.timeoutId) clearTimeout(this.timeoutId);
  }
}
